"use client";
import { cn as e } from "../lib/utils.js";
import { MaterialIcon as t } from "../core/icon/material-icon.js";
import * as n from "react";
import { cva as r } from "class-variance-authority";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import * as o from "@radix-ui/react-dialog";
//#region src/shadcn/sheet.tsx
var s = o.Root, c = o.Trigger, l = o.Close, u = o.Portal, d = n.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ i(o.Overlay, {
	className: e("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", t),
	...n,
	ref: r
}));
d.displayName = o.Overlay.displayName;
var f = r("fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500", {
	variants: { side: {
		top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
		bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
		left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
		right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
	} },
	defaultVariants: { side: "right" }
}), p = n.forwardRef(({ side: n = "right", className: r, children: s, ...c }, l) => /* @__PURE__ */ a(u, { children: [/* @__PURE__ */ i(d, {}), /* @__PURE__ */ a(o.Content, {
	ref: l,
	className: e(f({ side: n }), r),
	...c,
	children: [s, /* @__PURE__ */ a(o.Close, {
		className: "absolute right-4 top-4 inline-flex size-4 items-center justify-center rounded-sm p-0 leading-none opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary",
		children: [/* @__PURE__ */ i(t, {
			name: "close",
			size: "default"
		}), /* @__PURE__ */ i("span", {
			className: "sr-only",
			children: "Close"
		})]
	})]
})] }));
p.displayName = o.Content.displayName;
var m = ({ className: t, ...n }) => /* @__PURE__ */ i("div", {
	className: e("flex flex-col space-y-2 text-center sm:text-left", t),
	...n
});
m.displayName = "SheetHeader";
var h = ({ className: t, ...n }) => /* @__PURE__ */ i("div", {
	className: e("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", t),
	...n
});
h.displayName = "SheetFooter";
var g = n.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ i(o.Title, {
	ref: r,
	className: e("text-lg font-semibold text-foreground", t),
	...n
}));
g.displayName = o.Title.displayName;
var _ = n.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ i(o.Description, {
	ref: r,
	className: e("text-sm text-muted-foreground", t),
	...n
}));
_.displayName = o.Description.displayName;
//#endregion
export { s as Sheet, l as SheetClose, p as SheetContent, _ as SheetDescription, h as SheetFooter, m as SheetHeader, d as SheetOverlay, u as SheetPortal, g as SheetTitle, c as SheetTrigger };
